// ============================================================================
// ORDERING
// ============================================================================

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum ListOrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

/** Discriminator for PieceAuthor tagged-union: the `kind` field on collab/product author objects. */
export enum PieceAuthorKind {
  Member = 'member',
  User = 'user',
}

/** Who authored rows/artifacts in DB tables that use `author_kind` or similar. */
export enum ActorKind {
  User = 'user',
  Operative = 'operative',
  Chair = 'chair',
  Watchdog = 'watchdog',
  Envoy = 'envoy',
  System = 'system',
}

/** chat_message.author is a narrow subset */
export enum ChatAuthor {
  User = 'user',
  Envoy = 'envoy',
  System = 'system',
}

/** field_change_log.source */
export enum FieldChangeSource {
  Step = 'step',
  User = 'user',
  System = 'system',
  Fork = 'fork',
}

/** field_change_log.field_type */
export enum FieldValueType {
  Boolean = 'boolean',
  String = 'string',
  Number = 'number',
  Date = 'date',
  // Entity reference. Serializer accepts either a MikroORM Reference, a plain
  // object with `id`, or a raw FK scalar (string or number) and always emits
  // the id as a string. Use this for tracked manyToOne fields regardless of
  // whether the target table is UUID-keyed or integer-keyed.
  Ref = 'ref',
  // JSON/JSONB column. Serializer emits JSON.stringify(value); deserializer
  // returns JSON.parse. Full-blob diff (the whole object is rewritten on any
  // change) — structural per-key diffs are out of scope for now.
  Json = 'json',
}

/** Round status for API responses */
export enum RoundStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  Failed = 'failed',
  Pending = 'pending',
  Running = 'running',
}

/** Structural change types for context tree tracking */
export enum ChangeType {
  Added = 'added',
  Removed = 'removed',
  Altered = 'altered',
}

/** Expiration policy for piece lifespans */
export enum ExpirePolicy {
  AfterTurn = 'after_turn',   // Expires at this exact step
  FullRound = 'full_round',   // Expires at same step, next round
  RoundEnd = 'round_end',     // Expires at Reflect step of next round
  Never = 'never',            // No expiration (pinned)
}

/** Generic list sort direction for API query params */
export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export const ACTOR_KIND_VALUES = Object.freeze(Object.values(ActorKind));

export const CHAT_AUTHOR_VALUES = Object.freeze(Object.values(ChatAuthor));

export const ROUND_STATUS_VALUES = Object.freeze(Object.values(RoundStatus));

export const CHANGE_TYPE_VALUES = Object.freeze(Object.values(ChangeType));

export const EXPIRE_POLICY_VALUES = Object.freeze(Object.values(ExpirePolicy));

export const SORT_DIRECTION_VALUES = Object.freeze(Object.values(SortDirection));
